'use client';

import { useState } from 'react';
import CrisisRiskHeader from './CrisisRiskHeader';
import TodayCheckInSummary from './TodayCheckInSummary';
import LiveVisualWellnessCheck from './LiveVisualWellnessCheck';
import ScheduleTriggerCall from './ScheduleTriggerCall';
import WellnessTrends from './WellnessTrends';
import CallHistory from './CallHistory';
import AICrisisPrediction from './AICrisisPrediction';

const CheckInsInteractive = () => {
  const [contactId] = useState('margaret_chen_001');
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleRefresh = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <div className="space-y-8">
      {/* Page Header */}
      <div className="mb-6">
        <h1 className="text-3xl font-heading font-bold text-foreground mb-2">
          Kin Check
        </h1>
        <p className="text-muted-foreground">
          Daily AI wellness monitoring for Margaret
        </p>
      </div>

      {/* Section 1: Crisis Risk Score */}
      <CrisisRiskHeader contactId={contactId} refreshTrigger={refreshTrigger} />

      {/* Section 2: Today's Check-In Summary */}
      <TodayCheckInSummary contactId={contactId} refreshTrigger={refreshTrigger} />

      {/* Section 3: Live Visual Wellness Check */}
      <LiveVisualWellnessCheck contactId={contactId} onSave={handleRefresh} />

      {/* Section 4: Schedule/Trigger Call */}
      <ScheduleTriggerCall contactId={contactId} onCallComplete={handleRefresh} />

      {/* Section 5: 30-Day Wellness Trends */}
      <WellnessTrends contactId={contactId} refreshTrigger={refreshTrigger} />

      {/* Section 6: Call History */}
      <CallHistory contactId={contactId} refreshTrigger={refreshTrigger} />

      {/* Section 7: AI Crisis Prediction */}
      <AICrisisPrediction contactId={contactId} refreshTrigger={refreshTrigger} />
    </div>
  );
};

export default CheckInsInteractive;